"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DefaultOption = exports.DefaultOptionContainer = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_components_1 = __importDefault(require("styled-components"));
const style_1 = __importDefault(require("style"));
const Paragraph_1 = require("../Paragraph/Paragraph");
function toBackground({ isSelected }) {
    return isSelected ? style_1.default.Color.Blue.S400 : 'auto';
}
function toColor({ isSelected, theme }) {
    return isSelected ? style_1.default.Color.Blue.S50 : theme.Color.Text.Secondary;
}
function toWeight({ isSelected }) {
    return isSelected ? style_1.default.Text.Weight.Heavy : style_1.default.Text.Weight.Base;
}
function toHoverBackground({ isSelected, theme }) {
    return isSelected ? style_1.default.Color.Blue.S500 : theme.Color.Layout.Background;
}
function toHoverColor({ isSelected, theme }) {
    return isSelected ? theme.Color.Layout.Lightest : theme.Color.Text.Primary;
}
exports.DefaultOptionContainer = styled_components_1.default.div `
  border-radius: ${style_1.default.Design.Rounding.Tertiary};
  cursor: pointer;
  padding: ${style_1.default.Layout.Spacing.Small};
  background: ${toBackground};

  ${Paragraph_1.ParagraphContainer} {
    font-weight: ${toWeight};
    color: ${toColor};
  }

  &:hover {
    background: ${toHoverBackground};

    ${Paragraph_1.ParagraphContainer} {
      color: ${toHoverColor};
    }
  }
`;
function DefaultOption({ isSelected = false, onClick, option, }) {
    return ((0, jsx_runtime_1.jsx)(exports.DefaultOptionContainer, Object.assign({ onClick: onClick, isSelected: isSelected }, { children: (0, jsx_runtime_1.jsx)(Paragraph_1.Paragraph, { children: option.label }) })));
}
exports.DefaultOption = DefaultOption;
